<template>
    <div class="reqError" v-if="reqError">
        <img src="@\assets\logo-fundacion-forge.png">
        <span>
            <i class="material-icons">error</i>
            El enlace al que intentas acceder no está disponible.
        </span>
    </div>
    <Loader v-else />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter} from 'vue-router';
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue'
import persistentData from '@/plugins/persistentData';

const route = useRoute();
const router = useRouter();
const store = useStore();

const reqError = ref(false);

async function redirect(){
    try {
        let req = await store.dispatch('customLink_getCourseId', route.query.name);
        persistentData.set('customLinkId', req.data.id);
        router.push(`/course/${req.data.targetId}?t=OD`);
    } catch (error) {
        console.log(error)
        reqError.value = true;
    }
}

onMounted(()=>{
    redirect();
})

</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
.reqError{
    padding-top: 36px;
    width: 90%;
    max-width: 420px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    img{
        width: 140px;
    }
    span{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: $red;
        font-size: 15px;
        font-weight: 600;
        .material-icons{
            font-size: 22px;
        }
    }
}
</style>